import {
	Action, Game, GameEvent,
} from 'gin-rummy-game-ui';

export class MultiplayerGameManager extends Game {
	#room;
	#_isMgm = true;

	constructor(room, deck) {
		super(deck);
		this.#room = room;
		// this.#room.state.listen('gameState', (newValue) => {
		// 	console.log('got a state update', newValue.toJSON());
		// 	this.#updateGameState(newValue.toJSON());
		// });
		this.#room.state.onChange(() => {
			const newState = this.#room.state.gameState.toJSON();
			this.#updateGameState(newState);
		});
		this.#updateGameState();
	}

	get isMgm() {
		return this.#_isMgm;
	}

	action(command, data, position) {
		this.#room.send('action', new Action(command, data, position));
	}

	emitNewState() {
		this.message(GameEvent.StateChanged, this.gameState);
	}

	startGame() {
		//squelch
	}

	newRound() {
		//squelch
	}

	#updateGameState(newGameState) {

		this.gameState = newGameState ?? this.#room.state.gameState.toJSON();
		this.emitNewState();
	}
}
